import { UnitInputField } from "./UnitInputField";
import { UnitInputFieldStyles } from "./UnitInputFieldStyles";
import { UnitInputFieldInnerTextbox } from "./UnitInputFieldInnerTextbox";
import { TextboxProps } from "../textbox/TextboxProps";
import { ValidationResult } from "../../base/ValidationResult";
import { NumberWithUnit } from "@mcleod/core";

export class TextboxNumber extends UnitInputFieldInnerTextbox {
    constructor(props: Partial<TextboxProps>, unitInputField: UnitInputField) {
        super({
            ...props,
            fillRow: true
        }, unitInputField);
        this._inputDiv.classList.add(UnitInputFieldStyles.textboxNumber);
    }

    override getDataValue(): number {
        const boundValue = this.getRelevantModelRow()?.get(this.unitInputField.field, null) as NumberWithUnit;
        if (boundValue?.number != null) {
            return boundValue.number;
        }
        return this.getBasicValue();
    }

    public get enabled(): boolean {
        return this.unitInputField?.numberDisabledByServer !== true && super.enabled;
    }

    public set enabled(value: boolean) {
        super.enabled = value;
    }

    override validate(checkRequired: boolean, showErrors: boolean = true): ValidationResult[] {
        const result = super.validate(checkRequired, showErrors);
        if (result != null) {
            for (let x=0 ; x<result.length ; x++) {
                if (result[x]?.validationMessage?.toLowerCase() === "this field is required") {
                    result[x].validationMessage = "The value is required";
                }
            }
        }
        return result;
    }
}
